module.exports = __webpack_public_path__ + "static/img/brees-2006-slide-5.383a8ab.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brees-2006-slide-5.jpg
// module id = ucKf
// module chunks = 1